module.exports = __webpack_public_path__ + "static/img/client-code.2a221b55.png";